import { useState, useEffect, createContext, useContext } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteImagesContext = createContext({});

export const SiteImagesProvider = ({ children }) => {
  const [images, setImages] = useState({});

  useEffect(() => {
    axios.get(`${API}/static-images`).then(res => setImages(res.data)).catch(() => {});
  }, []);

  return (
    <SiteImagesContext.Provider value={images}>
      {children}
    </SiteImagesContext.Provider>
  );
};

export const useSiteImages = () => useContext(SiteImagesContext);
